import { useEffect, useState, useRef, useMemo } from 'react';
import { INIT_ENCOUNTER_NAME, INIT_ENCOUNTER, buildNestedFolders, filterFolders, generateUniqueId } from '../../../constants';
import FolderList from './FolderList';

const DropdownMenu = ({adminView, streamingEncounter, savedEncounters, setSavedEncounters, handleLoadEncounter, currentEncounter, setCurrentEncounter, socket}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [collapsedFolders, setCollapsedFolders] = useState({});
    const [search, setSearch] = useState(""); // 1. Add search state
    const dropdownRef = useRef(null);

    // Build nested folder structure
    const nestedFolders = useMemo(() => buildNestedFolders(savedEncounters), [savedEncounters]);
    const filteredFolders = useMemo(() => filterFolders(nestedFolders, search), [nestedFolders, search]);

    function clickEncounterDropdownMenuX(event, encounter) {
        event.stopPropagation();
        let updatedEncounterList = savedEncounters.filter(e => e.encounterGuid !== encounter.encounterGuid)
        setSavedEncounters(updatedEncounterList);
        
        if(currentEncounter.encounterGuid === encounter.encounterGuid) {
            setCurrentEncounter({...INIT_ENCOUNTER, encounterGuid: generateUniqueId()})
        }
        
        socket.emit("deleteEncounter", encounter.encounterGuid)
        console.log("%cDeleted Encounter: " + encounter.encounterName + ' - ' + encounter.encounterGuid, "background: #fdfd96;")


    }
    
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleDropDownOptionClicked = (encounter) => {
        setIsOpen(false);
        handleLoadEncounter(encounter);
    };

    let buttonString = "No Encounters"
    if(savedEncounters?.length !== 0) {
        buttonString = currentEncounter.encounterName === INIT_ENCOUNTER_NAME ? "Encounters..." : "Encounter: "
    }

    return (
        <div className="dropdown" ref={dropdownRef}>
            <button className="dmViewButton dropdownButton" onClick={() => setIsOpen(!isOpen)} disabled={savedEncounters.length === 0}>
                {buttonString}
                {currentEncounter && currentEncounter.encounterName !== INIT_ENCOUNTER_NAME && 
                    <p style={{margin: 0, textWrap: 'nowrap'}}>
                        <b>{currentEncounter.encounterName}</b>
                    </p>
                }
            </button>
        {isOpen && savedEncounters.length !== 0 && (
            <div>
                {/* Search input is now directly below the button */}
                
                <ul className="dropdownMenu" style={{
                    maxHeight: currentEncounter.encounterGuid ? "55vh" : "25vh",
                    borderTop: "2px solid rgb(105, 19, 19)",
                    paddingLeft: 0,
                    overflowX: 'hidden'
                }}>
                    <input
                        id='encounterSearch'
                        type="text"
                        placeholder="Search Encounters/Folders"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        style={{
                            width: '97%',
                            padding: "4px 0px 4px 2px",
                            margin: '0',
                            border: "2px solid rgb(157, 125, 72)",
                            fontSize: "0.8em",
                        }}
                        autoFocus={true}
                    />
                    <FolderList
                        folders={filteredFolders}
                        onEncounterClick={handleDropDownOptionClicked}
                        streamingEncounter={streamingEncounter}
                        adminView={adminView}
                        clickEncounterDropdownMenuX={clickEncounterDropdownMenuX}
                        currentEncounter={currentEncounter}
                        setCurrentEncounter={setCurrentEncounter}
                        collapsedFolders={collapsedFolders}
                        setCollapsedFolders={setCollapsedFolders}
                    />
                </ul>
            </div>
        )}
      </div>
    );
};

export default DropdownMenu;